var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPrinter32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 16a1 1 0 100-2 1 1 0 000 2zm4-1a1 1 0 11-2 0 1 1 0 012 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 4.25a1.75 1.75 0 011.744 1.606L23.75 6v3.25h1c1.065 0 1.92.86 1.995 1.93l.005.153v9.334c0 1.088-.806 1.997-1.85 2.077l-.15.006h-1V27A1.75 1.75 0 0122 28.75H10A1.75 1.75 0 018.25 27v-4.25h-1c-1.065 0-1.92-.86-1.995-1.93l-.005-.153v-9.334c0-1.088.806-1.997 1.85-2.077l.15-.006h1V6a1.75 1.75 0 011.606-1.744L10 4.25h12zm-13.75 17v-2h15.5v2h1c.238 0 .453-.203.493-.486l.007-.097v-9.334c0-.299-.19-.532-.422-.576l-.078-.007H7.25c-.238 0-.453.203-.493.486l-.007.097v9.334c0 .299.19.532.422.576l.078.007h1zM22.25 6v3.25H9.75V6l.007-.057A.25.25 0 0110 5.75h12l.057.007A.25.25 0 0122.25 6zM9.75 20.75h12.5V27a.25.25 0 01-.25.25H10l-.057-.007A.25.25 0 019.75 27v-6.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrinter32);
export default __webpack_public_path__ + "static/media/icon-printer-32.da77acd6.svg";
export { ForwardRef as ReactComponent };